import clsx from 'clsx';
import * as React from 'react';
import isNil from 'lodash/isNil';
import { colors } from '@ovpn-ui/styles';
import Text from '../Text';
import getBoxStyles from '../_internal/utils/getBoxStyles';
import HiddenInput from '../_internal/components/HiddenInput';
import maybeElementId from '../_internal/utils/maybeElementId';
import maybeDataTestId from '../_internal/utils/maybeDataTestId';
import { Container, Appearance, ContentWrapper } from './Radio.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function Radio(props, ref) {
  const {
    disabled = undefined,
    className,
    direction = 'ltr',
    title,
    description,
    size = 'md',
    'aria-label': ariaLabel,
    'data-testid': dataTestId,
    id,
    ..._htmlAttributes
  } = props;
  const {
    boxStyles: boxProps,
    restProps: htmlAttributes
  } = getBoxStyles(_htmlAttributes);
  const shouldRenderSmallRadio = size === 'sm';
  return /*#__PURE__*/_jsxs(Container, {
    forwardedAs: "label",
    className: clsx('ovpn-radio-container', className),
    "aria-label": title || ariaLabel,
    ...boxProps,
    tabIndex: disabled ? -1 : undefined,
    $disabled: disabled,
    $direction: direction,
    ...maybeDataTestId(dataTestId),
    children: [/*#__PURE__*/_jsx(HiddenInput, {
      className: "ovpn-radio-input",
      type: "radio",
      ...htmlAttributes,
      disabled: disabled,
      "aria-disabled": disabled ? true : undefined,
      ref: ref,
      ...maybeElementId(id)
    }), /*#__PURE__*/_jsx(Appearance, {
      className: "ovpn-radio-appearance",
      "aria-hidden": "true",
      $disabled: disabled,
      $small: shouldRenderSmallRadio,
      $withContent: isNil(title) ? undefined : true
    }), title && /*#__PURE__*/_jsxs(ContentWrapper, {
      children: [/*#__PURE__*/_jsx(Text, {
        color: colors.neutralTextTitle,
        variant: shouldRenderSmallRadio ? 'textSm' : 'textMd',
        ...maybeElementId(id, 'label'),
        children: title
      }), description && /*#__PURE__*/_jsx(Text, {
        color: colors.neutralTextSubtitle,
        variant: "textSm",
        ...maybeElementId(id, 'description'),
        children: description
      })]
    })]
  });
}
export default /*#__PURE__*/React.forwardRef(Radio);